import { render } from "./OwnitBanner.vue?vue&type=template&id=0738bc62&scoped=true"
import script from "./OwnitBanner.vue?vue&type=script&lang=js"
export * from "./OwnitBanner.vue?vue&type=script&lang=js"

import "./OwnitBanner.vue?vue&type=style&index=0&id=0738bc62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0738bc62"]])

export default __exports__